import services from "../services";
import * as types from "./mutation-type";

export const ActionSetObservacao = ({ commit }, payload) => {
    commit(types.SET_OBSERVACAO, payload)
}

export const ActionSendPayment = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendPayment(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}
export const ActionGetSimulationYapay = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetSimulationYapay(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetSimulationPagarme = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetSimulationPagarme(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetSimulationPagSeguro = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetSimulationPagSeguro(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}


export const ActionSendGetNetPaymentCard = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendGetNetPaymentCard(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendIpagPaymentCredit = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendIpagPaymentCredit(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendIpagPaymentBillet = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendIpagPaymentBillet(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendPagSeguroPaymentCard = ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.ActionSendPagSeguroPaymentCard(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendPagSeguroPaymentBillet = ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.ActionSendPagSeguroPaymentBillet(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetPublicKeyPagSeguro = ({_}) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetPublicKeyPagSeguro()
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}
